import { render, staticRenderFns } from "./certDialog.vue?vue&type=template&id=38616a27&scoped=true&"
import script from "./certDialog.vue?vue&type=script&lang=js&"
export * from "./certDialog.vue?vue&type=script&lang=js&"
import style0 from "./certDialog.vue?vue&type=style&index=0&id=38616a27&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38616a27",
  null
  
)

export default component.exports